import React from 'react';
import '../../componentsStyling/Header.css';
import LogoImage from '../../assets/FSUlogo.png';
import { IconButton } from '@mui/material';

function LoginHeader() {

    return (
        <header className='header'>
            <nav>
                <div className='header-content-left'>
                    <IconButton alt="Profile" aria-label="logo">
                        <img src={LogoImage} alt="Ferris State University Logo" style={{ height: '75px', width: 'auto', marginLeft: '40px'}} />
                    </IconButton>

                    <div className='title'>
                        <p>TDMP Media</p>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default LoginHeader;
